import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, Stack, Typography } from "@mui/material";
import { T } from "../routes/Translate";

// Enlaces a las páginas públicas e institucionales. Además de servirle al
// visitante, le dan a Google caminos rastreables entre las páginas públicas.
const LINKS = [
  { to: "/explore", label: <T>Explorar</T> },
  { to: "/precios", label: <T>Precios que seguimos</T> },
  { to: "/about", label: <T>Quiénes somos</T> },
  { to: "/faq", label: <T>Preguntas frecuentes</T> },
  { to: "/contact", label: <T>Contacto</T> },
  { to: "/store-directory", label: <T>Tiendas</T> },
  { to: "/terms", label: <T>Términos y condiciones</T> },
  { to: "/privacyPolicy", label: <T>Política de privacidad</T> },
  { to: "/delete-account", label: <T>Eliminar cuenta</T> },
];

const PublicFooter = ({ sx }) => (
  <Box component="footer" sx={{ mt: 4, py: 2, textAlign: "center", ...sx }}>
    <Stack direction="row" flexWrap="wrap" justifyContent="center" columnGap={2} rowGap={1}>
      {LINKS.map((l) => (
        <Link key={l.to} component={RouterLink} to={l.to} underline="hover" sx={{ fontSize: 13, color: "text.secondary" }}>
          {l.label}
        </Link>
      ))}
    </Stack>
    <Typography sx={{ mt: 1.5, fontSize: 12, color: "text.disabled" }}>
      © {new Date().getFullYear()} Dapur Tecnología - Notiline
    </Typography>
  </Box>
);

export default PublicFooter;
